/**
 * A faster alternative to setting innerHTML to an empty string
 * @param {HTMLElement} element
 */
function removeChildren(element) {
    while (element.lastChild) {
        element.removeChild(element.lastChild);
    }
}

/**
 * Returns the element's value or an empty string
 * @param {HTMLElement} element
 * @return {string}
 */
function elementValue(element) {
    return (element && element.value) || "";
}

/**
 * Export functions
 */
export {
    removeChildren, // TODO: Getting a requirejs exception when using this from AutoCompleteSearch
    elementValue
};
